import { Injectable } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { WebSocketSubject } from 'rxjs/webSocket';
import { Observable, Subject } from 'rxjs';
import { selectMessagingUrl } from '../../../store/profile/profile.state';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { webSocket } from 'rxjs/webSocket';
import { MessageTypeEnum } from '../../../enum/message-type.enum';
import {
    messengerActionUpdate, messengerQuotingComplete,
    messengerQuotingInProgress,
    messengerQuotingMessage,
    messengerQuotingQueued
} from '../../../store/messenger/messenger.actions';
import { LocaleService } from './locale.service';

@Injectable({
    providedIn: 'root'
})
export class MessagingService {

    public messages$: Subject<any> = new Subject<any>();

    private RETRY_SECONDS: 10;
    private connection$: WebSocketSubject<any>;
    private url: string = null;

    constructor(private store: Store<AppState>, private localeService: LocaleService) {
        this.store.select(selectMessagingUrl).pipe(
            filter(url => !!url),
            distinctUntilChanged()
        ).subscribe((url) => {
            this.url = url;
            if (this.connection$) {
                this.connection$.unsubscribe();
            } else {
                this.connect();
            }
        });
    }

    connect(): void {
        if (this.connection$) {
            const connection$ = this.connection$;
            this.connection$ = null;
            connection$.unsubscribe();
        }
        this.connection$ = webSocket(this.url);
        this.connection$.subscribe(
            (msg) => {
                this.messages$.next(msg); // some listeners need to filter the stream (action updates)
                this.received(msg);       // some listeners use effects (quotes)
            },
            (error) => {
                console.log('Messaging Socket Error');
                console.log(error);
                setTimeout(() => this.connect(), this.RETRY_SECONDS * 1000);
            },
            () => {
                console.log('Messaging Socket Finished.  Reconnecting...');
                this.connect();
            }
        );
    }

    received(message: any): void {
        switch (message.type) {
            case MessageTypeEnum.ACTION_UPDATE:
                this.store.dispatch(messengerActionUpdate({ action: message.action }));
                break;
            case MessageTypeEnum.QUOTING_QUEUED:
                this.store.dispatch(messengerQuotingQueued({ id: message.shipment }));
                break;
            case MessageTypeEnum.QUOTING_IN_PROGRESS:
                this.store.dispatch(messengerQuotingInProgress({
                    id: message.shipment,
                    progress: Math.min(message.progress, 99),
                    quotes: message.quotes ? message.quotes : [],
                    messages: message.messages ? message.messages.map((s) => this.localeService.createServerMessage(s)) : []
                }));
                break;
            case MessageTypeEnum.QUOTING_MESSAGE:
                this.store.dispatch(messengerQuotingMessage({
                    id: message.shipment,
                    messages: message.messages.map((s) => this.localeService.createServerMessage(s))
                }));
                break;
            case MessageTypeEnum.QUOTING_COMPLETE:
                this.store.dispatch(messengerQuotingComplete({
                    id: message.shipment,
                    quotes: message.quotes,
                    messages: message.messages ? message.messages.map((s) => this.localeService.createServerMessage(s)) : [],
                    preSelectedId: message.preSelectedId
                }));
                break;
        }
    }

}
